<script setup lang="ts">

import { DefaultSections, usePresentation, type SectionMeta } from "@presentation/Types";
const presentation = usePresentation();
const firstAppendixIndex = presentation.sections.findIndex( s => s.isAppendix );

let count = 1;

</script>

<template>

    <Page>
        <div class="grid grid-cols-5 gap-6 2xl:gap-8 3xl:gap-10 w-full h-full py-28">
            
            <template v-for="(section, index) in presentation.sections.filter( (s:SectionMeta) => s.isHidden !== true )">
            
                <div
                    v-if="index == firstAppendixIndex" 
                    class="text-cyan-500 uppercase
                    col-span-full text-xl 2xl:text-2xl 3xl:text-3xl font-semibold 
                    mt-10 2xl:mt-14 3xl:mt-16 first:!mt-0 -mb-4 2xl:-mb-6 3xl:-mb-8">
                    Appendix
                </div>
                
                <div class="
                    col-span-full text-lg 2xl:text-xl 3xl:text-2xl font-semibold 
                    mt-10 2xl:mt-14 3xl:mt-16 first:!mt-0 -mb-4 2xl:-mb-6 3xl:-mb-8"
                    :class="section.isAppendix ? 'text-cyan-500' : 'text-emerald-500'">
                    {{ section.title }}
                </div>
                
                <a v-for="( page, index ) in section.pages"
                   class="
                        cursor-pointer
                        transition-all 300ms ease
                        hover:scale-105 hover:brightness-[135%]"
                   @click="() => presentation.goto( section.name, index )">
                   <img :src="page.screenshot" 
                        class=" rounded-md overflow-hidden ring-1 p-0.5 bg-gray-950 ring-white brightness-125 shadow-lg"
                        :onerror="`this.onerror = null; this.src = '/images/${presentation.key}/pending.jpg'`" />
                    <div class="text-white/60 mt-2 flex leading-5">
                        <div class="text-white mr-1.5">{{ count++ }}: </div>
                        <div class="grow">{{ page.title }}</div>
                    </div>
                </a>

            </template>

            <!-- FILLER -->
            <div class="h-28 col-span-full" />

        </div>
    </Page>

</template>